module.exports = __webpack_public_path__ + "img/sweetbonanza.cf048ed7.gif";